import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap, map } from 'rxjs';
import { ApiService } from './api';

@Injectable({ providedIn: 'root' })
export class AdminAuthService {
  private api    = inject(ApiService);
  private router = inject(Router);

  token    = signal<string | null>(localStorage.getItem('admin_token'));
  fullname = signal<string | null>(localStorage.getItem('admin_fullname'));

  isLoggedIn(): boolean { return !!this.token(); }

  requestOtp(email: string): Observable<{ sent: boolean }> {
    return this.api.adminRequestOtp(email);
  }

  verifyOtp(email: string, otp: string): Observable<void> {
    return this.api.adminVerifyOtp(email, otp).pipe(
      tap(res => {
        localStorage.setItem('admin_token', res.token);
        localStorage.setItem('admin_fullname', res.fullname);
        this.token.set(res.token);
        this.fullname.set(res.fullname);
      }),
      tap(() => this.router.navigate(['/admin/queue'])),
      map(() => void 0),
    );
  }

  logout(): void {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_fullname');
    this.token.set(null);
    this.fullname.set(null);
    this.router.navigate(['/admin']);
  }
}
